import { isMobile } from "../modules/utilities";

//const carouselWidth = document.querySelector('.paged-carousel__items').offsetWidth;
const carouselBP = [0, 768, 1023];

let windowWidth = window.innerWidth;
let pageBreaks = 1;

carouselBP.forEach((bp, i) => {
  if (windowWidth >= bp) {
    pageBreaks = i + 1;
  }
})

export const resetCarousel = (carousels) => {
  windowWidth = window.innerWidth;
  carouselBP.forEach((bp, i) => {
    if (windowWidth >= bp) {
      pageBreaks = i + 1;
    }
  })

  carousels.forEach((carousel) => {
    initCarousel(carousel);
  });
}

export const initCarousel = (carousel, active) => {
  const items = carousel.querySelectorAll('.paged-carousel__item');
  const carouselWidth = carousel.querySelector('.paged-carousel__items').offsetWidth;
  const gridGap = calculateDistance(items[0], items[1]);
  const itemsPerPage = Math.ceil(carouselWidth / (items[0].offsetWidth + gridGap));
  let pageCount = Math.ceil(items.length / itemsPerPage);

  if(isNaN(pageCount)) pageCount = 1;

  items.forEach((item, i) => {
    item.style.transform = 'translateX(0px)';
  })

  carousel.querySelector('.current').innerText = 1;
  carousel.querySelector('.total').innerText = pageCount;
  carousel.setAttribute('data-page', 1);
  carousel.setAttribute('data-max', pageCount);

  carousel.querySelector('.prev').classList.add('disabled');
  if (pageCount === 1) {
    carousel.querySelector('.paged-carousel__nav').classList.add('hide');
    carousel.querySelector('.next').classList.add('disabled');
  } else {
    carousel.querySelector('.paged-carousel__nav').classList.remove('hide');
    carousel.querySelector('.next').classList.remove('disabled');
  }

  if(active){
    carousel.classList.add('active');
  } else {
    carousel.style.display = 'none';
  }

  initSwipe(carousel);
}

export const initCarouselActions = (carousel) => {
  let items = carousel.querySelectorAll('.paged-carousel__item');
  let pageCount = Math.ceil(items.length / pageBreaks);

  if (pageCount === 1) {
    carousel.querySelector('.next').classList.add('disabled');
  } else {
    carousel.querySelector('.prev').addEventListener('click', handlePrevPage);
    carousel.querySelector('.next').addEventListener('click', handleNextPage);
  }
}

export const initSwipe = (carousel) => {
  let startX;
  let endX;

  carousel.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
  });

  carousel.addEventListener('touchmove', (e) => {
    endX = e.touches[0].clientX;
  });

  carousel.addEventListener('touchend', () => {
    if (startX > endX + 50) {
      handleNextPage({ currentTarget: carousel.querySelector('.next') });
    } else if (startX < endX - 50) {
      handlePrevPage({ currentTarget: carousel.querySelector('.prev') });
    }
  });
}

const handlePrevPage = (e) => {
  const target = e.currentTarget;
  if(target.classList.contains('disabled')) return;
  const targetcarousel = target.closest('.paged-carousel');
  const carouselWidth = targetcarousel.querySelector('.paged-carousel__items').offsetWidth;
  const targetcarouselItems = targetcarousel.querySelectorAll('.paged-carousel__item');
  const nextButton = targetcarousel.querySelector('.next');
  let targetPage = parseInt(targetcarousel.getAttribute('data-page'));

  if (targetPage > 1) {
    targetPage--;
    targetcarousel.setAttribute('data-page', targetPage);
    targetcarousel.querySelector('.current').innerText = targetPage;
    nextButton.classList.remove('disabled');
  }

  let transform = 0;
  let gridGap = 20;

  if (targetPage === 1) {
    target.classList.add('disabled');
  } else {
    let gridGap = calculateDistance(targetcarouselItems[0], targetcarouselItems[1]);
    transform = ((targetPage - 1) * carouselWidth) + (gridGap * (targetPage - 1));
  }

  targetcarouselItems.forEach((item) => {
    item.style.transform = `translateX(-${transform}px)`;
  });

  console.log(target);
  console.log(targetcarousel);
  console.log(carouselWidth);
  console.log(gridGap);
  console.log(transform);
}

const handleNextPage = (e) => {
  console.log(isMobile);
  const target = e.currentTarget;
  if(target.classList.contains('disabled')) return;
  const targetcarousel = target.closest('.paged-carousel');
  //const targetGrid = targetcarousel.querySelector('.paged-carousel__items');
  const carouselWidth = targetcarousel.querySelector('.paged-carousel__items').offsetWidth;
  const targetcarouselItems = targetcarousel.querySelectorAll('.paged-carousel__item');
  const maxCount = parseInt(targetcarousel.getAttribute('data-max'));
  const prevButton = targetcarousel.querySelector('.prev');
  let targetPage = parseInt(targetcarousel.getAttribute('data-page'));

  if (targetPage < maxCount) {
    targetPage++;
    targetcarousel.setAttribute('data-page', targetPage);
    targetcarousel.querySelector('.current').innerText = targetPage;
    prevButton.classList.remove('disabled');
  }

  let transform = 0;

  if(targetPage === maxCount) {
    target.classList.add('disabled');
  }

  // GET GRID GAP
  let gridGap = calculateDistance(targetcarouselItems[0], targetcarouselItems[1]);
  transform = ((targetPage - 1) * carouselWidth) + (gridGap * (targetPage - 1));

  targetcarouselItems.forEach((item) => {
    item.style.transform = `translateX(-${transform}px)`;
  });
}

const calculateDistance = (element1, element2) => {
  if(element2){
    const rect1 = element1.getBoundingClientRect();
    const rect2 = element2.getBoundingClientRect();
    return(rect2.left - rect1.right);
  } else {
    return 0
  }
}



// WEBPACK FOOTER //
// ./src/js/components/carousel.js